module.exports = __webpack_public_path__ + "img/PERSAT-G.68096757.png";